var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('app-image'),_vm._m(0),_vm._m(1),_c('div',{staticClass:"container"},[_c('div',{staticClass:"container1"},[_c('router-view')],1)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"localDiv"},[_c('div',{staticClass:"localContent"},[_vm._v(" 当前位置：网站首页 / "),_c('span',[_vm._v("成功案例")])])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productMenuDiv",attrs:{"id":"showLocation"}},[_c('p',[_vm._v("成功案例")])])
}]

export { render, staticRenderFns }